import apiClient from "../common/apiClient";

export default class DoctorMedicalMappingController {
  async Create(data, token) {
    try {
      return await apiClient.post("/doc-medical", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(id, data, token) {
    try {
      return await apiClient.put("/doc-medical/" + id, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/doc-medical/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllDoctorMedicalCenterMapping(token) {
    try {
      return await apiClient.get("/getAllDocMedical", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
